<template>
    <div>
        <v-card 
            outlined
            class="pa-4 ma-0"
        > 
        
        <v-form ref="formImovel">
           <div> 
                <v-row dense v-if="property && property.length == 0">
                    <v-col class="auto">
                        <alert-component :alert="alerts.property_first"></alert-component>
                    </v-col>    
                </v-row>    
                <v-row dense>
                    <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <v-text-field
                            v-model="params_property.codigo"
                            outlined
                            dense
                            :class="$css_field"
                            :rules="[rules.required]"
                            @keydown.enter="loadProperties"
                        >
                            <template v-slot:label>
                                <span :class="$css_field">Código do imóvel</span>
                            </template>
                        </v-text-field>
                    </v-col>  
                    <v-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
                        <v-btn
                            dark
                            color="primary"
                            @click="validateProperty"
                            :class="$css_button"
                        >
                            Pesquisar
                        </v-btn>
                    </v-col>    
                </v-row>
            </div>
        </v-form> <!-- formImovel -->

        <!-- mostra imovel -->
            <v-row dense>                
                <v-col v-if="property && property.length > 0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-text-field
                        v-model="property[0].complete_address"
                        outlined
                        dense
                        :class="$css_field"
                        filled
                        readonly    
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Endereço</span>
                        </template>
                    </v-text-field>
                </v-col>      
            </v-row>
        <!-- fim mostra imovel -->



        <div v-if="client && client.length == 0 && property.length > 0">
            <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <alert-component :alert="alerts.client_first"></alert-component>
                </v-col>    
            </v-row> 
        </div>

        <!-- form pesquisa cliente -->

        <div v-if="property.length > 0">  
            <v-form ref="formClient">             
                <v-row dense>
                    <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                        <v-select
                            v-model="tipo_pessoa"
                            :items="items.tipo_pessoas"
                            outlined
                            dense
                            :class="$css_field"
                            :rules="[rules.required]"
                        >
                            <template v-slot:label>
                                <span :class="$css_field">Tipo pessoa</span>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <v-text-field
                            v-model="tipo_pessoa_doc"
                            v-mask="tipo_pessoa == 'PF' ? ['###.###.###-##'] : ['##.###.###/####-##']"
                            outlined
                            dense
                            :class="$css_field"
                            :rules="[rules.required]"
                            @keydown.enter="loadClients"
                        >
                            <template v-slot:label>
                                <span :class="$css_field">
                                    <span v-if="tipo_pessoa == 'PF'">CPF</span>
                                    <span v-if="tipo_pessoa == 'PJ'">CNPJ</span>
                                </span>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                        <v-text-field
                            v-model="params_client.telefone_search"
                            v-mask="['(##) ####-####', '(##) #####-####']"
                            outlined
                            dense
                            :class="$css_field"
                            :rules="[rules.required]"
                            :key="'phone-field'"
                        >
                            <template v-slot:label>
                                <span :class="$css_field">Telefone</span>
                            </template>
                        </v-text-field>  
                    </v-col>  
                    <v-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
                        <v-btn
                            dark
                            color="primary"
                            @click="validateClient"
                            :class="$css_button"
                        >
                            Pesquisar
                        </v-btn>
                    </v-col>    
                </v-row>
            </v-form>
        </div>   
        <!-- fim form pesquisa cliente -->    

    <div>   
        <v-form ref="form">   
        <div v-if="show.form">                      
            <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                        v-model="item.nome"
                        outlined
                        dense
                        :class="$css_field"
                        :rules="[rules.required]"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Nome</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.telefone"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        outlined
                        dense
                        :class="$css_field"
                        :rules="[rules.required]"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Telefone</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.telefone2"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Telefone 2</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                        v-model="item.email"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">E-mail</span>
                        </template>
                    </v-text-field>
                </v-col> 
            </v-row>
            <v-row dense>
                <v-col v-if="tipo_pessoa == 'PF'" cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.cpf"
                        v-mask="['###.###.###-##']"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">CPF</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col v-if="tipo_pessoa == 'PF'" cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.rg"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">RG</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col v-if="tipo_pessoa == 'PF'" cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-menu
                        v-model="calendar.data_nascimento"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                dense
                                outlined
                                v-model="item.data_nascimento"
                                label="Dt nascimento"
                                append-icon="mdi-calendar-range"
                                readonly
                                v-on="on"
                                :class="$css_field"
                            ></v-text-field>
                        </template>

                        <v-date-picker locale="pt-br" v-model="data_nascimento" @input="calendar.data_nascimento = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col v-if="tipo_pessoa == 'PF'" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-text-field
                        v-model="item.nacionalidade"
                        outlined
                        dense
                        :class="$css_field"
                        :rules="[rules.required]"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Nacionalidade</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col v-if="tipo_pessoa == 'PF'" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-select
                        v-model="item.estado_civil"
                        :items="items.estado_civil"
                        :rules="[rules.required]"
                        item-text="text"
                        item-value="text"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Estado Civil</span>
                        </template>
                    </v-select>
                </v-col>
                <v-col v-if="tipo_pessoa == 'PF'" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-text-field
                        v-model="item.profissao"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Profissão</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-currency-field
                        v-model="item.renda_mensal"
                        outlined
                        dense
                        prefix="R$"
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Renda mensal</span>
                        </template>
                    </v-currency-field>
                </v-col>
                <v-col v-if="tipo_pessoa == 'PJ'" cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.cnpj"
                        v-mask="['##.###.###/####-##']"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">CNPJ</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col v-if="tipo_pessoa == 'PJ'" cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.inscricao_estadual"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Inscriçāo estadual</span>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row class="mt-2">
                <v-col class="auto">
                    <alert-component :alert="alerts.client_address"></alert-component>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.cep"
                        @blur="searchCep(item.cep)"
                        v-mask="['#####-###']"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">CEP</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <v-text-field
                        v-model="item.endereco"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Endereço</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                        v-model="item.bairro"
                        label="Bairro"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Bairro</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <v-text-field
                        v-model="item.cidade"
                        label="Cidade"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Cidade</span>
                        </template> 
                    </v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
                    <v-text-field
                        v-model="item.estado"
                        label="Estado"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Estado</span>
                        </template>
                    </v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
                    <v-text-field
                        v-model="item.numero"
                        label="Número"
                        type="number"
                        outlined
                        dense
                        :class="$css_field"                      
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Número</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col  cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.complemento"
                        label="Complemento"
                        outlined
                        dense
                        required
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Complemento</span>
                        </template>
                    </v-text-field>
                </v-col>                  
            </v-row>
            </div>

            <div v-if="show.form">
            <v-row class="mt-2">
                <v-col>
                    <alert-component :alert="alerts.client_proposal"></alert-component>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-select
                        v-model="item.setor"
                        :items="items.setor"
                        :rules="[rules.required]"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Setor</span>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-currency-field
                        v-model="item.valor_proposta"
                        outlined
                        dense
                        :rules="[rules.required, rules.min]"
                        prefix="R$"
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Vl Proposta</span>
                        </template>
                    </v-currency-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-currency-field
                        v-model="item.comissao"
                        outlined
                        dense
                        :rules="[rules.required]"
                        prefix="%"
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Comissão</span>
                        </template>
                    </v-currency-field>
                </v-col>
                <v-col v-if="item.setor == 'Locação'" cols="12" xs="12" sm="12"  md="3" lg="3" xl="3">
                    <v-select
                        v-model="item.garantia"
                        :items="items.garantias"
                        outlined
                        dense
                        :class="$css_field"
                        :rules="[rules.required]"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Garantia</span>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-textarea
                        v-model="item.proposta"
                        outlined
                        dense
                        :class="$css_field"
                        :rules="[rules.required]"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Proposta</span>
                        </template>
                    </v-textarea>
                </v-col>
            </v-row> 

            <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="text-right">
                    <v-btn
                        dark
                        color="primary"
                        @click="validate"
                        :class="$css_button"
                    >
                    Gravar
                    </v-btn>
                </v-col>    
            </v-row>
            </div>            
        </v-form>    
        </div> 
        </v-card>  

        <v-dialog
            v-model="check_exists"
            transition="dialog-bottom-transition"
            max-width="600"
        >
                <v-card>
                    <v-toolbar
                        color="error"
                        dark
                    >   
                        Imóvel em processo de proposta
                        <v-spacer/>
                        <v-btn
                            text
                            @click="check_exists = false"
                        >Fechar</v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div class="text-h6 pa-12">
                            <span class="font-weight-bold">O imóvel informado já possui uma proposta em andamento. Por favor, não siga com o cadastro dessa proposta. </span> <br />
                            
                            <div class="mt-4">
                            Para maiores informações entre em contato com a gerência.
                            </div>
                        </div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                    <v-btn
                        text
                        @click="check_exists = false"
                    >Fechar</v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog> 


        <v-dialog
            v-model="dialog.alertClient"
            transition="dialog-bottom-transition"
            max-width="600"
        >
                <v-card>
                    <v-toolbar
                        color="error"
                        dark
                    >   
                        Cliente encontrado
                        <v-spacer/>
                        <v-btn
                            text
                            @click="dialog.alertClient = false"
                        >Fechar</v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div class="text-h6 pa-6">
                            <div v-if="client && client.length > 0 && client[0].facs && client[0].facs.length > 0">
                               O sistema encontrou o cliente que consta na FAC COD - {{ client[0].facs[0].codigo }} <br />
                               Toda alteração nas informações do cliente irá impactar diretamente na FAC. 
                            </div>

                             <div v-if="client && client.length > 0 && client[0].properties && client[0].properties.length > 0">
                               O sistema encontrou o cliente que consta como proprietario no COD - {{ client[0].properties[0].codigo }} <br />
                               Toda alteração nas informações do cliente irá impactar diretamente no cadastro do proprietário. 
                            </div>

                             
                            <div class="mt-4">
                            Para maiores informações entre em contato com a gerência.
                            </div>
                        </div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                    <v-btn
                        text
                        @click="dialog.alertClient = false"
                    >Fechar</v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog> 


    </div>
</template>

<script>
import { estadoCivilItems } from '@/constants/estadoCivilItems';
import { TIPO_PESSOA } from './config_proposals/config_proposals'
import { GARANTIA_LOCACAO_ITEMS } from '@/components/properties/config_properties/config_properties.js'
import AlertComponent from '@/components/alert/AlertComponent.vue'

export default {
    components: {
        AlertComponent,
    },

    computed: {
        me () {
          return this.$store.state.auth.me
        },
    },

    mounted() {
        window.scrollTo(0, 0);
    },
    
    watch: {
        data_nascimento () {
            this.item.data_nascimento = this.formatDate(this.data_nascimento)
        },
    }, 

    data () {
        return {
            property: [],
            client: [],
            tipo_pessoa: '',
            tipo_pessoa_doc: '',
            check_exists: false,
            show: {
                form: false
            },

            dialog: {
                alertClient: false
            },

            alerts: {
                property_first: {
                    type: 'warning',
                    icon: 'mdi-alert-outline',
                    messages: ['Informe o código do imóvel da proposta']
                },
                client_first: {
                    type: 'warning',
                    icon: 'mdi-alert-outline',
                    messages: ['Informe o CPF ou CNPJ do cliente']
                },
                client_address: {
                    type: 'warning',
                    icon: 'mdi-alert-outline',
                    messages: ['Informe ou confirme o endereço atual do cliente']
                },
                client_proposal: {
                    type: 'warning',
                    icon: 'mdi-alert-outline',
                    messages: ['Informe os dados da proposta']
                }
            },

            params_property: {
                codigo: '',
                paginate: 'false',
            },

            params_client: {
                cpf_search: '',
                cnpj_search: '',
                paginate: 'false',
                telefone_search: ''
            },

            item: {
                data_nascimento: '',
                endereco: '',
                bairro: '',
                cidade: '',
                estado: '',
                comissao: null,
                estado_civil: null
            },

            items: {
                estado_civil: estadoCivilItems,
                garantias: GARANTIA_LOCACAO_ITEMS,
                tipo_pessoas: TIPO_PESSOA,
                setor: ['Venda','Locação']
            },
            rules: {
                required: value => !!value || 'Obrigatório',
                min:  v => (v && v.length >= 7) || 'Mininmo de 7 numeros',
                email: value => /.+@.+/.test(value) || 'E-mail precisa ser válido'
            },

            data_nascimento: '',

            calendar: {
                data_nascimento: false,
            },
        }
    },

    methods: {
        loadProperties () {
            this.property = []
            this.$store.dispatch('loadPropertiesExcel', this.params_property) 
                        .then(response => {
                            this.property = response.data
                            if(this.property.length == 0){
                                this.$snotify.error('Imóvel não encontrado. Por favor, verifique se o código está correto.')
                            }
                            this.checkProposal()
                        })
                        .catch(error => {
                            this.$snotify.error('Imóvel não encontrado')
                        })
        },

        checkProposal () {
            this.check_exists = false;
            const params = {};
            params.multiple_codigo_imovel = this.params_property.codigo;
            params.multiple_status = ['Nova','Pendente','Em análise'];
            params.check_store = 'true';

            this.$store.dispatch('loadPromisseProposals', params) 
                        .then(response => {
                            if(response.meta && response.meta.total && response.meta.total > 0){
                                this.check_exists = true;
                            }
                        })
        },

        loadClients () {
            this.clearClient()
            this.client = []
            this.show.form = false
            this.params_client.cpf_search = ''
            this.params_client.cnpj_search = '' 

            if(this.tipo_pessoa_doc){
                var doc = this.onlyNumber(this.tipo_pessoa_doc)
                if(this.tipo_pessoa == 'PF'){
                    this.params_client.cpf_search = doc
                    this.item.cpf = doc
                }
                if(this.tipo_pessoa == 'PJ'){
                    this.params_client.cnpj_search = doc
                    this.item.cnpj = doc
                }
            }
            this.item.telefone = this.params_client.telefone_search;

            this.$store.dispatch('loadClients', this.params_client) 
                        .then(response => {
                            this.client = response.data
                            if(this.client.length > 0){
                                this.setClient(this.client[0])
                                this.dialog.alertClient = true
                                
                            }
                            this.show.form = true
                        }) 
        },

        searchCep(value){
            if(!value) return ''
            this.$store.dispatch('loadCep', value) 
                        .then(response => {
                            this.setAddress(response)
                        })
        },

        setAddress(address){
            this.item.endereco = address.logradouro
            this.item.bairro = address.bairro
            this.item.cidade = address.localidade
            this.item.estado = address.uf
        },

        setClient(client){   
            this.item.nome = client.nome
            this.item.telefone = client.telefone && client.telefone != null ? client.telefone : this.item.telefone
            this.item.telefone2 = client.telefone2
            this.item.email = client.email
            this.item.cpf = client.cpf && client.cpf != null ? client.cpf : this.item.cpf
            this.item.rg = client.rg 
            this.item.inscricao_estadual = client.inscricao_estadual
            this.item.data_nascimento = client.data_nascimento
            this.item.nacionalidade = client.nacionalidade
            this.item.estado_civil = client.estado_civil
            this.item.profissao = client.profissao
            this.item.cep = client.cep,
            this.item.endereco = client.endereco,
            this.item.bairro = client.bairro,
            this.item.cidade = client.cidade,
            this.item.estado = client.estado,
            this.item.numero = client.numero,
            this.item.complemento = client.complemento
        },

        clearClient(){       
            this.item.nome = '',
            this.item.telefone = '',
            this.item.telefone2 = '',
            this.item.email = '',
            this.item.rg = '', 
            this.item.inscricao_estadual = '',
            this.item.data_nascimento = '',
            this.item.nacionalidade = '',
            this.item.estado_civil = '',
            this.item.cep = '',
            this.item.endereco = '',
            this.item.bairro = '',
            this.item.cidade = '',
            this.item.estado = '',
            this.item.numero = '',
            this.item.complemento = '',
            this.item.profissao = '',
            this.item.renda_mensal = ''
        },

        validate () {
            if (this.$refs.form.validate()) {
                this.store()
            }
        },

        validateProperty () {
            if (this.$refs.formImovel.validate()) {
                this.loadProperties()
            }
        },

        validateClient () {
            if (this.$refs.formClient.validate()) {
                this.loadClients()
            }
        },

        store(){
            this.item.property_id = this.property[0].id
            const action = 'storeProposal'    
            this.$store.dispatch(action, this.item)
                        .then(response => {  
                            if(!response.data.id){
                                this.$snotify.error(response.data.error)
                            }else{
                                this.item = response.data
                                this.$snotify.success('Cadastro com sucesso!')

                                const routeName = this.me.profile === 'Master' || this.me.profile === 'Gerente' ? 'admin.proposals.edit' : 'admin.proposals.show';

                                this.$router.push({
                                    name: routeName,
                                    params: { id: this.item.id },
                                    query: { store: 'true' }
                                });
                            }
                        })
                        .catch(error => {
                            this.$snotify.error('Erro no cadastro')
                        }) 
                   
        }, 
        
    },
}
</script>

<style scoped>

</style>